<template>
  <div class="homeContainer">
    <div class="home-top">
      <div class="head">
        <div class="companyName">
          <div>
            <a href="/"><img src="../../public/images/campany.png" alt="" /></a>
          </div>
        </div>
        <div class="phone">
          <!-- <img  src="../assets/shouji.png" alt="">
              13241800875 -->
          <img class="menuCopy" @click="isSeeList()" src="../assets/menu.png" alt="" />
        </div>
      </div>
      <!-- 移动端的menu菜单 -->
      <div class="copyMenu" v-if="isSeeMenuList">
        <a href=""><div class="item">首页</div></a>
        <a href="aboutUs"><div class="item">关于我们</div></a>
        <a href="news"> <div class="item">公司资讯</div></a>
        <a href="businessnew"><div class="item">公司业务</div></a>
        <a href="joinUs"><div class="item" style="border-bottom: none">联系我们</div></a>
      </div>

      <div class="menu" v-if="!isSeeMenuList">
        <a href=""><div class="item">首页</div></a>
        <div class="border">|</div>
        <a href="aboutUs"><div class="item">关于我们</div></a>
        <div class="border">|</div>
        <a href="news"> <div class="item">公司资讯</div></a>
        <div class="border">|</div>
        <el-popover placement="bottom" trigger="hover">
          <template #reference>
            <a href="businessnew"><div class="item">公司业务</div></a>
          </template>
          <a href="businessnew?type=1"><div class="one">培训服务</div></a>
          <a href="businessnew?type=2"><div class="one">资本服务</div></a>
          <a href="businessnew?type=3"><div class="one">产业服务</div></a>
          <a href="businessnew?type=4"><div class="one">咨询服务</div></a>
        </el-popover>

        <div class="border">|</div>
        <el-popover class="box-item" title="" content="暂未开放" placement="bottom">
          <template #reference>
            <a href=""><div class="item">数据库</div></a>
          </template>
        </el-popover>

        <div class="border">|</div>
        <a href="joinUs"><div class="item">联系我们</div></a>
      </div>
      <div id="header_font" v-if="!isSeeMenuList">
        <p>产业与资本相互赋能</p>
        <p>助力新质生产力发展</p>
      </div>
    </div>
    <div v-if="!isSeeMenuList">
      <div class="serviceList">
        <div class="item">
          <a href="businessnew?type=1"><div class="tit">培训服务</div></a>
          <!-- <div class="msg">科创培训 资本培训 传承培训</div> -->
        </div>
        <div class="item">
          <a href="businessnew?type=2"><div class="tit">资本服务</div></a>
          <!-- <div class="msg">资本对接 产业服务 股权激励</div> -->
        </div>
        <div class="item">
          <a href="businessnew?type=3"><div class="tit">产业服务</div></a>
          <!-- <div class="msg">地方政府对接 科技成果转化 政产学研合作</div> -->
        </div>
        <div class="item" style="border-right: none">
          <a href="businessnew?type=4"><div class="tit">咨询服务</div></a>
          <!-- <div class="msg">中关村科技评论 中关村资本论坛</div> -->
        </div>
      </div>
      <div class="news">
        <div class="left"><img src="../assets/news.png" alt="" /></div>
        <div class="newsContent">
          <div class="title">
            <a href="news"><div class="msg">公司要闻</div></a>
          </div>
          <div class="box">
            <a href="https://mp.weixin.qq.com/s/322vJEf2v432HYCN-ZZJjg" target="_blank">
              <div class="top">
                <div class="titile">
                 中资服Family | “国产GPU第二股”沐曦股份科创板挂牌上市
                </div>
                <div class="time"><text>发布时间:</text> 2025.12.17</div>
              </div>
              <div class="bottom">
              12月17日，中关村资本市场服务数字领导力DBA学员企业——沐曦集成电路（上海）股份有限公司（股票简称：沐曦股份，股票代码：688802.SH）正式在上海证券交易所科创板挂牌上市。
              </div>
            </a>
          </div>
          <div class="box">
            <a href="https://mp.weixin.qq.com/s/aII08jfTP2Mh-1kN5fpTMA" target="_blank">
              <div class="top">
                <div class="titile">
                 课程回顾 | 当WEB3遇见香港：WEB3领军人才计划首期班开课！
                </div>
                <div class="time"><text>发布时间:</text> 2025.12.16</div>
              </div>
              <div class="bottom">
               2025年12月12-14日，由中关村资本市场服务主办的 “WEB3领军人才计划” 首期班课程在香港正式开启。
              </div>
            </a>
          </div>
          <div class="box">
            <a href="https://mp.weixin.qq.com/s/E0SWeBwmZBYPuaXprLmPNg" target="_blank">
              <div class="top">
                <div class="titile">
                 DBA实践课堂 | 产学融合新范式：数字领导力企业家学者DBA北京实践课堂成功举办
                </div>
                <div class="time"><text>发布时间:</text> 2025.11.12</div>
              </div>
              <div class="bottom">
                2025年11月6日，数字领导力企业家学者暨拉文大学DBA北京实践课堂成功举办。通过企业参访+深度研讨的形式，为同学们提供了沉浸式交流学习、思想碰撞的平台，共同探讨数字化时代背景下的企业创新发展新路径。
              </div>
            </a>
          </div>
          <div class="box">
            <a href="https://mp.weixin.qq.com/s/NdaXV-Q449CudY9EyRKfFg" target="_blank">
              <div class="top">
                <div class="titile">
                 活动报道 | 全球 RWA 前沿探索与商业实践，共探行业新机遇
                </div>
                <div class="time"><text>发布时间:</text> 2025.10.29</div>
              </div>
              <div class="bottom">
                2025年10月26日，由学说科技、中关村资本市场服务主办——“全球 RWA 前沿探索与商业实践” 活动在学说空间成功举办，此次活动汇聚各行业精英、聚焦全球RWA，展开深度研讨。
              </div>
            </a>
          </div>
          <div class="box">
            <a href="https://mp.weixin.qq.com/s/lw8H5PCjM-I0qVINytzDlw" target="_blank">
              <div class="top">
                <div class="titile">
                 DBA海外课堂 | 走进越南产业核心，解锁中企出海新机遇
                </div>
                <div class="time"><text>发布时间:</text> 2025.09.23</div>
              </div>
              <div class="bottom">
                9 月 17 日-18 日，数字领导力DBA 海外课堂・越南站进入核心产业考察与深度交流阶段。同学们先后走进中国纺织龙头在越核心基地、越南代表性纺织企业、True North国际学校等产业标杆基地，为中企出海越南提供了宝贵的实战参考。
              </div>
            </a>
          </div>
          <div class="box">
            <a href="https://mp.weixin.qq.com/s/GbaEM4Awg9HhCeqGjVGZig" target="_blank">
              <div class="top">
                <div class="titile">
                 DBA海外课堂 | 初识越南，解码越南投资热土
                </div>
                <div class="time"><text>发布时间:</text> 2025.09.19</div>
              </div>
              <div class="bottom">
                2025年9月14日-18日，数字领导力DBA海外课堂走进越南。在此期间，DBA同学们通过政策解读、企业参访、金融交流与文化体验，全方位探索越南投资机遇，加深了同学们对越南经济的了解，搭建起中越企业合作对接的桥梁。
              </div>
            </a>
          </div>
         
          <!-- <div class="box">
            <a href="https://mp.weixin.qq.com/s/H74XyYQiFsE9YrL86Vt1Mw" target="_blank">
              <div class="top">
                <div class="titile">
                  中关村资本市场服务与上海天使会、企麟企服共同发布全新科创企业服务项目
                </div>
                <div class="time"><text>发布时间:</text> 2025.04.30</div>
              </div>
              <div class="bottom">
                2025年4月25日，乖乖数科主办的“升维·聚势·全域增长-第五届行业赋能大会”圆满举办，500+行业领袖齐聚一堂，共同探寻数字化转型新范式。中关村资本市场服务有限公司参与的战略生态合作仪式成为焦点之一，为企业服务领域注入全新活力。
              </div>
            </a>
          </div>
          <div class="box">
            <a href="https://mp.weixin.qq.com/s/QS3Y6cinwiNCjjAHiRa4Fw" target="_blank">
              <div class="top">
                <div class="titile">
                  活动报道｜科创企业家领军人才培养计划：企业闭门研讨和业务对接会（第二期）圆满举行
                </div>
                <div class="time"><text>发布时间:</text> 2025.04.29</div>
              </div>
              <div class="bottom">
                2025年4月26日，“新质科创·逐浪资本”科创企业家领军人才培养计划：企业闭门研讨和业务对接会（第二期）在学说空间圆满举行。活动聚焦关税壁垒加剧背景下半导体科创企业的挑战与机遇，特邀国投创合及多家芯片半导体企业参与，同时吸引了众多与路演
              </div>
            </a>
          </div> -->
          
        </div>
      </div>
      <div class="bigIMg"><img src="../assets/big02.jpg" alt="" /></div>
      <div class="plate">
        <div class="top">
          <div class="title">
            <div class="imgBox"><img src="../assets/wangxia.png" alt="" /></div>
            <div>
              <div class="chName">公司业务</div>
              <div class="enName">/COMPANY BUSINESS</div>
            </div>
          </div>
          <div class="msg">管理赋能、业务赋能、资本赋能</div>
        </div>
        <div class="boxList">
          <div class="item">
            <a href="businessnew?type=1">
              <img src="../assets/fengmian1.jpg" alt="" />
              <div class="name">
                <p>培训服务</p>
                <div class="btn">查看详细</div>
              </div>
            </a>
          </div>
          <div class="item">
            <a href="businessnew?type=2">
              <img src="../assets/fengmian2.jpg" alt="" />
              <div class="name">
                <p>资本服务</p>
                <div class="btn">查看详细</div>
              </div>
            </a>
          </div>
          <div class="item">
            <a href="businessnew?type=3">
              <img src="../assets/fengmian3.jpg" alt="" />
              <div class="name">
                <p>产业服务</p>
                <div class="btn">查看详细</div>
              </div>
            </a>
          </div>
          <div class="item" style="margin-right: 0px">
            <a href="businessnew?type=4">
              <img src="../assets/fengmian4.jpg" alt="" />
              <div class="name">
                <p>咨询服务</p>
                <div class="btn">查看详细</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="plate plate2">
        <div class="top">
          <div class="title">
            <div class="imgBox"><img src="../assets/wangxia.png" alt="" /></div>
            <div>
              <div class="chName">合作伙伴</div>
              <div class="enName">/PARTNER</div>
            </div>
          </div>
          <div class="msg">管理赋能、业务赋能、资本赋能</div>
        </div>
        <div class="bigImg">
          <!-- 合作方轮播图 -->
          <div class="cardBox">
            <el-carousel :interval="4000" height="276px" indicator-position="none">
              <el-carousel-item>
                <img src="../assets/partner1.jpg" alt="" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/partner2.jpg" alt="" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/partner3.jpg" alt="" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/partner4.jpg" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="home-bottom">
        <div class="box">
          <div class="left">
            <div>联系我们</div>
            <!-- <div>工作时间：09:00—18:00</div> -->
            <!-- <div>服务热线： 高老师  13241800875</div> -->
            <div>邮箱：contact@zgccms.com</div>
            <div>地址：北京海淀区中关村大街11号e世界B区一层</div>
          </div>
          <div class="linkBox">
            <el-select v-model="value" @change="getNewLink(value)" placeholder="相关链接">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="right">
            <div class="addWx">
              <img src="../assets/gzh.jpg" alt="" />
              <div class="wxtext">公众号二维码</div>
            </div>
            <!-- <div class="addWx"><img src="../assets/getmore.png" alt=""></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const isSeeMenuList = ref(false);

const isSeeList = () => {
  isSeeMenuList.value = true;
};

const value = ref("");
const options = ref([
  {
    value: "https://www.tsinghua.edu.cn/",
    label: "清华大学",
  },
  {
    value: "https://www.pbcsf.tsinghua.edu.cn/",
    label: "清华大学五道口",
  },
  {
    value: "https://www.zgcgroup.com.cn/",
    label: "中关村发展",
  },
  {
    value: "https://www.51xueshuo.com/#/home",
    label: "学说平台",
  },
]);

const getNewLink = (current) => {
  window.open(current);
};
</script>

<style lang="less">
.homeContainer {
  .home-top {
    height: 580px;
    .head {
      padding: 58px 150px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
      .companyName {
        img {
          width: 250px;
        }
      }
      .phone {
        display: flex;
        width: 100px;
        font-size: 16px;
        color: #ffffff;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 15px;
        }
        .menuCopy {
          width: 16px;
          height: 16px;
          margin-left: 10px;
          display: none;
        }
      }
    }
    .menu {
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        .item {
          font-size: 16px;
          width: 226px;
          color: #ffffff;
        }
      }
      .border {
        color: #e1e1e1;
      }
    }
    #header_font {
      width: 576px;
      height: 131px;
      position: absolute;
      font-family: "微软雅黑";
      top: 36%;
      left: 50%;
      transform: translate(-50%, -50%) scale(1, 1);
      padding: 0;
      animation: mymove 10s infinite;
      p {
        width: 420px;
        height: 60px;
        font-size: 40px;
        font-family: "微软雅黑";
        // font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 60px;
        margin: 0 auto;
        letter-spacing: 6px;
      }
    }
    .copyMenu {
      width: 100%;
      background-color: #fff;
      height: 100vh;
      margin-top: 196px;
      a {
        color: #333;
        letter-spacing: 2px;
        .item {
          height: 45px;
          line-height: 45px;
          border-bottom: 1px solid #cecece;
        }
      }
    }
  }
  .home-top::after {
    box-shadow: 0 0 0px 100vh rgba(0, 0, 0, 0.6);
    z-index: -1;
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    //  top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .home-top::before {
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(../../public/images/homeBcnew.jpg) no-repeat center center,
      linear-gradient(180.06deg, rgb(46, 45, 45) 0.05%, rgb(30, 29, 29) 206.55%);
    background-size: cover;
    opacity: 1; /* 设置透明度 */
    z-index: -1; /* 确保伪元素在内容之下 */
    height: 580px;
  }
  .serviceList {
    display: flex;
    // align-items: center;
    // height: 190px;
    background: #d5d5d5;

    .item {
      flex: 1 1 calc(33.333% - 20px);
      padding: 30px;
      box-sizing: border-box;
      border-right: 1px solid #929293;
      .tit {
        color: #606060;
        // font-size: 20px;
        font-size: 18px;
      }
      .msg {
        font-size: 16px;
        color: #333;
        margin-top: 14px;
      }
    }
  }
  .news {
    background: #e1e1e1;
    padding-top: 30px;
    padding-bottom: 69px;
    display: flex;
    justify-content: center;
    .left {
      margin-right: 45px;
      img {
        width: 608px;
        height: 342px;
      }
    }
    .newsContent {
      height: 342px;
      .title {
        width: 560px;
        height: 70px;
        background-color: #fff;
        margin-bottom: 28px;
        .msg {
          width: 220px;
          height: 70px;
          line-height: 70px;
          background-color: #1866b6;
          color: #fff;
          font-size: 18px;
        }
      }
      .box {
        margin-bottom: 20px;
        .top {
          display: flex;
          .titile {
            color: #333333;
            font-size: 16px;
            width: 388px;
            text-overflow: ellipsis; /* 溢出显示省略号 */
            overflow: hidden; /* 溢出隐藏 */
            white-space: nowrap; /* 强制不换行 */
            text-align: left;
          }
          .time {
            margin-left: 25px;
            font-size: 14px;
            color: #999999;
          }
        }
        .bottom {
          margin-top: 16px;
          color: #999999;
          font-size: 14px;
          display: none;
          max-width: 560px;
          text-align: left;
          padding-right: 15px;
          line-height: 18px;
          height: 36px;
          overflow: hidden; /* 溢出隐藏 */
        }
      }
      .box:hover .bottom {
        //  display:block;
      }
      .box:first-child {
        .bottom {
          // display:block;
        }
      }
    }
  }
  .bigIMg {
    background: #e1e1e1;
    img {
      height: 207px;
      width: 1225px;
      object-fit: cover;
    }
  }
  .plate {
    background: #e1e1e1;
    padding-top: 50px;
    .top {
      margin-bottom: 32px;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0070b7;
        .imgBox {
          width: 52px;
          height: 52px;
          margin-right: 14px;
          img {
            width: 52px;
            height: 52px;
          }
        }

        .chName {
          font-size: 30px;
          font-weight: 600;
        }
        .enName {
          font-size: 10px;
          margin-top: 2px;
          text-align: left;
          //  font-weight: 600;
        }
      }
      .msg {
        margin-top: 8px;
        color: #606060;
        font-size: 16px;
        // font-weight: 600;
      }
    }
    .boxList {
      display: flex;
      justify-content: center;
      align-items: center;
      .item {
        margin-right: 32px;
        width: 280px;
        height: 380px;
        position: relative;
        img {
          height: 380px;
          width: 280px;
        }
        .name {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          padding-top: 130px;
          background-color: #000;
          opacity: 0.5;
          p {
            font-size: 20px;
            color: #fff;
            padding-bottom: 4px;
            border-bottom: 2px solid #fff;
            width: fit-content;
            margin: 0 auto;
            font-weight: 500;
          }
          .btn {
            width: 100px;
            height: 40px;
            margin: 76px auto 0 auto;
            padding-top: 8px;
            color: #606060;
            font-size: 14px;
            background-color: white;
            display: none;
            border-radius: 8px;
          }
        }
      }
      .item:hover .name {
        background-color: transparent;
        opacity: 1;
      }
      .item:hover .name .btn {
        display: block;
      }
    }
    .bigImg {
      img {
        width: 1225px;
        height: 500px;
        // object-fit:cover;
      }
      .cardBox {
        width: 1225px;
        margin: 0 auto;
        padding-bottom: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .plate2 {
    // padding-bottom: 269px;
  }
  .home-bottom {
    height: 330px;
    color: #fff;
    .box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 70px;
      width: 68%;
      margin: 0 auto;
      .left {
        width: 300px;
        text-align: left;
        line-height: 40px;
        font-size: 18px;
        white-space: nowrap;
      }
      .right {
        display: flex;
        // visibility:hidden;
        .addWx {
          img {
            width: 100px;
            height: 100px;
          }
          .wxtext {
            font-size: 14px;
          }
        }
      }
      .linkBox {
        width: 230px;
      }
    }
  }
  .home-bottom::after {
    box-shadow: 0 0 0px 330px rgba(0, 0, 0, 0.8);
    z-index: -1;
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    //  top: 0;
    right: 0;
    //  bottom: 0;
    left: 0;
  }

  .home-bottom::before {
    border-radius: 10px;
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    // top: 0;
    right: 0;
    // bottom: 0;
    left: 0;
    background: url(../../public/images/homeBc.png) no-repeat center center,
      linear-gradient(180.06deg, rgb(46, 45, 45) 0.05%, rgb(30, 29, 29) 206.55%);
    background-size: cover;
    opacity: 1; /* 设置透明度 */
    z-index: -1; /* 确保伪元素在内容之下 */
    height: 330px;
  }
}
.el-popper.is-light,
.el-popper.is-light > .el-popper__arrow:before {
  text-align: center;
}
.one {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #606266;
}
.one:hover {
  background-color: #0070b7;
  color: #fff;
  cursor: pointer;
}

/* 设备宽度小于768px时的样式 */
@media screen and (max-width: 768px) {
  body {
    min-width: 100%;
    font-size: 16px; /* 基准字体大小 */
  }
  .home-top {
    height: 246px !important;
    .head {
      padding: 10px 20px !important;
      padding-right: 10px !important;
      background: #032751 !important;
      .companyName {
        margin-top: 4px;
        img {
          width: 130px !important;
        }
      }
    }
    .phone {
      width: auto !important;
      font-size: 0.8rem !important;
      img {
        width: 14px !important;
        height: 14px !important;
        margin-right: 6px !important;
      }
      .menuCopy {
        display: block !important;
      }
    }
    #header_font {
      width: 60% !important;
      height: 100px !important;
      top: 150px !important;
      p {
        width: 200px !important;
        height: 30px !important;
        font-size: 14px !important;
        margin: 0 auto !important;
      }
    }
    .menu {
      display: none !important;
    }
  }
  .home-top::before {
    height: 246px !important;
  }
  .serviceList {
    .item {
      padding: 10px !important;
      .tit {
        font-size: 14px !important;
      }
      .msg {
        font-size: 12px !important;
        margin-top: 10px !important;
        display: none;
      }
    }
  }
  .news {
    padding-top: 10px !important;
    width: 100% !important;
    padding-bottom: 20px !important;
    .left {
      display: none;
      img {
        width: 100% !important;
        height: 200px !important;
      }
    }
    .newsContent {
      width: 100% !important;
      height: auto !important;
      .title {
        width: 100% !important;
        height: 30px !important;
        margin-bottom: 10px !important;
        .msg {
          width: 40% !important;
          height: 30px !important;
          line-height: 30px !important;
          font-size: 16px !important;
        }
      }
      .box {
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 10px !important;
        .top {
          align-items: center !important;
        }
        .bottom {
          font-size: 12px !important;
        }
        .titile {
          font-size: 14px !important;
          width: 100% !important;
        }
        .time {
          margin-left: 10px !important;
          font-size: 12px !important;
          text {
            display: none !important;
          }
        }
      }
    }
  }
  .bigIMg {
    width: 100% !important;
    height: 100px !important;
    img {
      width: 100% !important;
      height: 100px !important;
    }
  }
  .plate {
    padding-top: 10px !important;
    .top {
      margin-bottom: 12px !important;
      .title {
        .imgBox {
          width: 30px !important;
          height: 30px !important;
          margin-right: 4px;
          img {
            width: 30px !important;
            height: 30px !important;
          }
        }
        .chName {
          font-size: 16px !important;
        }
        .enName {
          font-size: 10px !important;
          margin-top: 2px !important;
        }
      }
      .msg {
        font-size: 10px !important;
        margin-top: 6px !important;
      }
    }
    .boxList {
      flex-wrap: wrap !important;
      justify-content: space-around !important;
      padding-left: 10px !important;
      padding-right: 10px !important;
      .item {
        width: auto !important;
        height: 130px !important;
        border-radius: 10px;
        margin-right: 0px !important;
        margin-bottom: 10px !important;
        // margin-right: 10px!important;
        img {
          width: 170px !important;
          height: 130px !important;
          border-radius: 10px;
        }
        .name {
          border-radius: 10px;
          padding-top: 45px !important;
          .btn {
            display: none !important;
          }
          p {
            font-size: 16px !important;
          }
        }
        &:nth-child(1) {
          // margin-left: 10px!important;
        }
      }
    }
    .bigImg {
      .cardBox {
        width: 100% !important ;
        padding-left: 10px !important ;
        padding-right: 10px !important ;
        padding-bottom: 10px !important;
        .el-carousel__container {
          height: 100px !important;
        }
        img {
          height: 100% !important;
          object-fit: contain !important;
        }
      }
    }
  }
  .plate2 {
    padding-bottom: 10px !important;
  }
  .home-bottom {
    height: 126px !important;
    .box {
      padding-top: 30px !important;
      justify-content: space-around;
      // padding-left: 20px;
      width: 90% !important;
      img {
        width: 80px;
        height: 100px;
      }
      .left {
        font-size: 12px !important;
        line-height: 20px !important;
      }
      .right {
        .addWx {
          img {
            width: 50px !important;
            height: 50px !important;
          }
          .wxtext {
            font-size: 8px !important;
          }
        }
      }
      .linkBox {
        width: 230px;
      }
    }
  }
  .home-bottom::before {
    height: 126px !important;
  }
  .home-bottom::after {
    box-shadow: 0 0 0px 66px rgba(0, 0, 0, 0.8) !important;
    width: 100% !important;
  }
}
</style>

<style lang="less">
/* 清除浏览器默认边距，
使边框和内边距的值包含在元素的width和height内 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  width: 100%;
  // min-width: 1200px;
  zoom: 1;
  margin: 0 auto;
}
a {
  // color: #333333;
}
a:link {
  text-decoration: none; /* 未访问的链接去除下划线 */
}

a:visited {
  text-decoration: none; /* 已访问的链接去除下划线 */
}

a:hover {
  text-decoration: none; /* 鼠标悬停时添加下划线，可根据需求调整 */
}

a:active {
  text-decoration: none; /* 激活状态的链接去除下划线 */
}

@keyframes mymove {
  0%,
  10% {
    transform: translate(-50%, -50%) scale(1, 1);
    opacity: 1;
  }
  10%,
  20% {
    transform: translate(-50%, -50%) scale(1.5, 1.5);
    opacity: 0;
  }
  20%,
  40% {
    transform: translate(-50%, -50%) scale(2, 2);
    opacity: 0;
  }
  40%,
  60% {
    transform: translate(-50%, -50%) scale(2, 2);
    opacity: 0;
  }
  60%,
  80% {
    transform: translate(-50%, -50%) scale(1.5, 1.5);
    opacity: 0;
  }
  80%,
  100% {
    transform: translate(-50%, -50%) scale(1, 1);
    opacity: 1;
  }
}
</style>
